/**
 * 디자인 시스템 아이콘 — Figma에서 내려받은 SVG 원본. 색이 다른 상태(active 등)는 별도 파일이다.
 * 새 아이콘은 src/shared/assets/icons 에 넣고 여기 등록해 재사용한다.
 */
import calendar from '@/shared/assets/icons/calendar.svg';
import checkboxCheck from '@/shared/assets/icons/checkbox-check.svg';
import check from '@/shared/assets/icons/check.svg';
import circleArrow from '@/shared/assets/icons/circle-arrow.svg';
import eyeOffError from '@/shared/assets/icons/eye-off-error.svg';
import eyeOff from '@/shared/assets/icons/eye-off.svg';
import filterActive from '@/shared/assets/icons/filter-active.svg';
import chevronDown from '@/shared/assets/icons/chevron-down.svg';
import chevronLeftSmall from '@/shared/assets/icons/chevron-left-small.svg';
import chevronLeft from '@/shared/assets/icons/chevron-left.svg';
import chevronRightSmall from '@/shared/assets/icons/chevron-right-small.svg';
import chevronRight from '@/shared/assets/icons/chevron-right.svg';
import chevronUpSmall from '@/shared/assets/icons/chevron-up-small.svg';
import chevronUp from '@/shared/assets/icons/chevron-up.svg';
import close from '@/shared/assets/icons/close.svg';
import filter from '@/shared/assets/icons/filter.svg';
import docsActive from '@/shared/assets/icons/docs-active.svg';
import docs from '@/shared/assets/icons/docs.svg';
import dot from '@/shared/assets/icons/dot.svg';
import hospitalActive from '@/shared/assets/icons/hospital-active.svg';
import hospital from '@/shared/assets/icons/hospital.svg';
import logout from '@/shared/assets/icons/logout.svg';
import search from '@/shared/assets/icons/search.svg';
import userActive from '@/shared/assets/icons/user-active.svg';
import user from '@/shared/assets/icons/user.svg';

export const ICONS = {
  /** 24 · light grey */
  calendar,
  /** 24 · accent (16 슬롯에 축소해서 쓴다) */
  check,
  /** 16 · 흰색 (체크박스 선택 표시) */
  checkboxCheck,
  /** 14 · light grey (외부 링크) */
  circleArrow,
  /** 24 · light grey (비밀번호 가림) / 오류 상태 */
  eyeOff,
  eyeOffError,
  /** 24 · accent (필터 적용됨) */
  filterActive,
  /** 24 · light grey */
  chevronDown,
  /** 24 · light grey */
  chevronUp,
  /** 24 · grey */
  chevronLeft,
  /** 24 · grey */
  chevronRight,
  /** 16 · light grey */
  chevronLeftSmall,
  /** 16 · light grey */
  chevronRightSmall,
  /** 16 · black */
  chevronUpSmall,
  /** 16 · black */
  close,
  /** 24 · light grey */
  filter,
  /** 4 · light grey 점 구분자 */
  dot,
  /** 16 · grey */
  logout,
  /** 24 · light grey */
  search,
  /** 24 · 메뉴 아이콘 (기본 light grey / active 흰색) */
  user,
  userActive,
  hospital,
  hospitalActive,
  docs,
  docsActive,
} as const;

export type IconName = keyof typeof ICONS;
